import type { ReactNode } from 'react';

export const SectionWithHeading = ({
  heading,
  children,
}: {
  heading: JSX.Element | string;
  children: ReactNode;
}) => {
  return (
    <div className="flex flex-col items-center">
      <div className="lg:w-3/5">
        <h2 className="text-center font-heading-condensed text-xl font-medium leading-7 tracking-tight text-primary-2-80 lg:text-3xl lg:leading-8">
          {heading}
        </h2>
      </div>
      {children}
    </div>
  );
};
